import PhaseFive from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseFive"
import React from "react"

const PhaseFivePage = () => {
    return (
        <React.Fragment>
            <PhaseFive />
        </React.Fragment>
    )
}
export default PhaseFivePage
